import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import DropdownInput from '../../common/DropdownInput'; // Adjust the path according to your project structure

const DropdownComponent = () => {
    // Sample options for the dropdown
    const options1 = [
        { value: "option1", label: "Option 1" },
        { value: "option2", label: "Option 2" },
        { value: "option3", label: "Option 3" },
    ];

    const options2 = [
        { value: "optionA", label: "Option A" },
        { value: "optionB", label: "Option B" },
        { value: "optionC", label: "Option C" },
        { value: "optionD", label: "Option D" },
    ];

    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Dropdown Input Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DropdownInput
                                    name="firstDropdown"
                                    id="firstDropdownInput"
                                    required={true}
                                    layout="below"
                                    options={options1}
                                    showHelp={true}
                                    helpText="Please select an option from the dropdown."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DropdownInput
    name="firstDropdown"
    id="firstDropdownInput"
    required={true}
    layout="below"
    options={options1}
    showHelp={true}
    helpText="Please select an option from the dropdown."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DropdownInput
                                    name="secondDropdown"
                                    id="secondDropdownInput"
                                    required={true}
                                    layout="below"
                                    options={options2}
                                    showHelp={true}
                                    helpText="Please select an option from the second dropdown."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DropdownInput
    name="secondDropdown"
    id="secondDropdownInput"
    required={true}
    layout="below"
    options={options2}
    showHelp={true}
    helpText="Please select an option from the second dropdown."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DropdownInput
                                    name="optionalDropdown"
                                    id="optionalDropdownInput"
                                    required={false}
                                    layout="below"
                                    options={options1}
                                    placeholder="Select an optional option"
                                    showHelp={true}
                                    helpText="This dropdown is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DropdownInput
    name="optionalDropdown"
    id="optionalDropdownInput"
    required={false}
    layout="below"
    options={options1}
    placeholder="Select an optional option"
    showHelp={true}
    helpText="This dropdown is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <DropdownInput
                                    name="clearableDropdown"
                                    id="clearableDropdownInput"
                                    required={true}
                                    layout="below"
                                    options={options2}
                                    showHelp={true}
                                    helpText="You can clear this selection."
                                    isClearable={true}
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<DropdownInput
    name="clearableDropdown"
    id="clearableDropdownInput"
    required={true}
    layout="below"
    options={options2}
    showHelp={true}
    helpText="You can clear this selection."
    isClearable={true}
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default DropdownComponent;
